import type {ComponentStageData, ComponentStageHeuristicDefinition} from '../../types'
import {SemanticTypes} from '../../preprocess/conversionDataBuilders'
import {getParent, updateTargetLayout} from '../common'
import type {StructureEntryItem} from '../../conversionDal/types'
import {getSourceLayoutPointer} from '../../conversionDal/utils/pointer'

const hideComponent = ({conversionDal, componentPointer}: ComponentStageData) => {
    updateTargetLayout(
        {conversionDal, componentPointer},
        {
            componentLayout: {
                hidden: true,
                type: 'ComponentLayout'
            },
            itemLayout: {},
            containerLayout: {},
            type: 'SingleLayoutData'
        }
    )

    const parentPointer = getParent(conversionDal, componentPointer)

    if (parentPointer) {
        conversionDal.modify(parentPointer, (currentValue: StructureEntryItem) => ({
            ...currentValue,
            components: currentValue.components?.filter(compId => compId !== componentPointer.id),
            hiddenComponents: (currentValue.hiddenComponents ?? []).concat([componentPointer.id])
        }))
    }
}

export const hideComponentsHeuristics: ComponentStageHeuristicDefinition[] = [
    {
        predicate: ({conversionDal, componentPointer}: ComponentStageData) =>
            conversionDal.get(componentPointer).semanticType === SemanticTypes.VERTICAL_LINE,
        apply: hideComponent,
        heuristicCode: 'HIDE VERTICAL LINE'
    },
    {
        predicate: ({conversionDal, componentPointer}: ComponentStageData) =>
            conversionDal.get(getSourceLayoutPointer(componentPointer))?.componentLayout?.hidden,
        apply: hideComponent,
        heuristicCode: 'HIDDEN CASCADE'
    }
]
